import { ParsedCssStyle } from '@wix/thunderbolt-components'
import { color } from '@wix/thunderbolt-commons'

export function fixBorderHairline(css: ParsedCssStyle, hasDropShadow: boolean): ParsedCssStyle {
	if (!hasDropShadow && css.borderRadius && css.borderWidth && css.borderColor) {
		const rgba = color.extractRGBA(css.borderColor)

		if (rgba) {
			const currentShadow = css.boxShadow
			css.boxShadow = `${currentShadow ? `${currentShadow}, ` : ''}inset 1px 1px 0 0 ${rgba},
 inset -1px 1px 0 0 ${rgba},
 inset 1px -1px 0 0 ${rgba},
 inset -1px -1px 0 0 ${rgba}`
		}
	}

	return css
}
